import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { fetchHomeGames } from '../redux/slice/home.slice';
import { setSelectedCategory, setSearchQuery } from '../redux/slice/game.slice';
import Hero from '../components/shop/Hero';
import Categories from '../components/shop/Categories';
import RecommendedGames from '../components/shop/RecommendedGames';
import DealsSection from '../components/shop/DealsSection';
import FloatingRocketAstronaut from '../components/shop/FloatingRocketAstronaut';
import RecentlyViewed from '../components/shop/RecentlyViewed';
import NewsletterSignup from '../components/common/NewsletterSignup';
import { Helmet } from 'react-helmet-async';

export default function Home() {
  const pageContainerRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // Reset category and search filters when landing on Home page
    dispatch(setSelectedCategory('All'));
    dispatch(setSearchQuery(''));
    dispatch(fetchHomeGames());
  }, [dispatch]);

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://cubegames.ca/#organization",
        "name": "Cube Games",
        "url": "https://cubegames.ca",
        "logo": "https://cubegames.ca/favicon.svg",
        "sameAs": []
      },
      {
        "@type": "WebSite",
        "@id": "https://cubegames.ca/#website",
        "url": "https://cubegames.ca",
        "name": "Cube Games",
        "publisher": {
          "@id": "https://cubegames.ca/#organization"
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://cubegames.ca/all-games?search={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }
    ]
  };

  return (
    <div
      ref={pageContainerRef}
      className="relative z-10 w-full flex flex-col justify-start"
    >
      <Helmet>
        <title>CUBE GAMES | Official Store - Premium PC & Console Games</title>
        <meta name="description" content="Explore and buy premium digital PC, Xbox, PlayStation, Nintendo Switch, and VR games at Cube Games. Fast downloads, secure payments, and incredible daily deals!" />
        <meta name="keywords" content="Cube Games, buy pc games, playstation games, xbox games, nintendo switch games, vr games, cheap digital game keys, indie games" />
        <link rel="canonical" href="https://cubegames.ca" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="CUBE GAMES | Official Store - Premium PC & Console Games" />
        <meta property="og:description" content="Explore and buy premium digital PC, Xbox, PlayStation, Nintendo Switch, and VR games at Cube Games. Fast downloads, secure payments, and incredible daily deals!" />
        <meta property="og:url" content="https://cubegames.ca" />
        <meta property="og:image" content="https://cubegames.ca/logo512.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CUBE GAMES | Official Store - Premium PC & Console Games" />
        <meta name="twitter:description" content="Explore and buy premium digital PC, Xbox, PlayStation, Nintendo Switch, and VR games at Cube Games. Fast downloads, secure payments, and incredible daily deals!" />
        <meta name="twitter:image" content="https://cubegames.ca/logo512.png" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      {/* 1. Fullscreen Cinematic Hero Block */}
      <Hero />

      {/* 2. Interactive Circular Categories list */}
      <Categories />

      {/* 3. Main Showcase Marketplace Grid with tabs */}
      <RecommendedGames />

      {/* 4. Large RGB Flash Deals Countdown Banner */}
      <DealsSection />

      {/* 5. Animated Rocket Astronaut (Peeking over Recently Viewed section matching Image 2) */}
      <FloatingRocketAstronaut />

      {/* 6. Recently Viewed & Personalized Picks */}
      <RecentlyViewed />

      {/* 7. Newsletter Signup */}
      <NewsletterSignup />

    </div>
  );
}
